// src/components/CustomInput.tsx
import React, {
  FC,
  InputHTMLAttributes,
  type ChangeEvent,
  type ComponentType,
} from 'react';
import type { SVGProps } from 'react';

export interface CustomInputProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  id: string;
  label?: string;
  Icon: ComponentType<SVGProps<SVGSVGElement>>;
  RightIcon?: ComponentType<SVGProps<SVGSVGElement>>;
  onRightIconClick?: () => void;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  error?: boolean;
  errorMessage?: string;
  password?: string;
}

const CustomInput: FC<CustomInputProps> = ({
  id,
  label,
  Icon,
  RightIcon,
  onRightIconClick,
  type = 'text',
  placeholder,
  value,
  onChange,
  error = false,
  errorMessage = '', // default here
  password,
  ...rest
}) => {
  const borderColor = type !== 'tel' && !value ? 'border-[#FF0000]' : (id !== 'confirmPassword' ? 'border-gray-300' : (password === value ? 'border-gray-300' : 'border-[#FF0000]'));
  const labelColor = error ? 'text-[#FF0000]' : 'text-gray-600';

  return (
    <div
      className={`w-full bg-white h-16 relative mb-2 mt-0 border-b-2 ${borderColor}`}
    >
      {label && (
        <label
          htmlFor={id}
          className={`absolute left-10 top-1 field-label ${labelColor} z-10`}
        >
          {label}
        </label>
      )}
      <Icon
        color='black'
        width={24}
        className='absolute left-3 z-20 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5'
      />
      <input
        id={id}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className='
            absolute inset-x-0 bottom-0
            w-full
            pl-10 pr-10 pb-2
            field-value
            placeholder:field-label placeholder:text-gray-400
            focus:outline-none focus:ring-0 focus:border-transparent
          '
        {...rest}
      />
      {RightIcon && onRightIconClick && (
        <button
          type='button'
          onClick={onRightIconClick}
          className='absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500'
          aria-label='toggle'
        >
          <RightIcon color='black' width={24} className='w-5 h-5' />
        </button>
      )}
      {/* now safe: errorMessage is always a string */}
      {error && errorMessage.length > 1 && (
        <p className={` ${labelColor} field-label  absolute top-16  `}>
          {errorMessage}
        </p>
      )}
    </div>
  );
};

export default CustomInput;
